import { SetupPermission } from 'src/app/core';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const Mobile: SetupPermission = PermissionsC.setupPages({
  pageLabels: [
    'end-users',
    'groups',
    'statistics',
    'metrics',
    'plans',
    'sim-and-line-management',
    'phone-number-management',
  ],
  productLineLabel: 'mobile-network',
});
